module.exports = __webpack_public_path__ + "img/visuel_2026_sans_slogan.eee04698.png";